import { useLocalStorage } from "@/services/localstorage/useLocalStorage";
import { Flex, Text, useToast } from "@chakra-ui/react";
import { Banner } from "@pufflig/prompt-studio-ui";
import { useState } from "react";
import * as Sentry from "@sentry/react";
import { useNotifications } from "./hooks/useNotifications";

export const AppBanner = () => {
  const { data: notifications, isLoading } = useNotifications();
  const [hidden, setHidden] = useLocalStorage<string[]>("hide:notifications", []);
  const notification = notifications?.filter((notification) => notification.type === "banner")[0];
  const shouldShow = notification?.notification_id && !hidden.includes(notification.notification_id);
  const toast = useToast();

  const [showBanner, setShowBanner] = useState(true);

  if (isLoading || !notification || !showBanner || !shouldShow) {
    return null;
  }

  const closeBanner = () => {
    setShowBanner(false);
    setHidden([...hidden, notification.notification_id]);
  };

  const onActionClick = async () => {
    try {
      toast({
        title: "Request sent!",
        description: "You have successfully requested access to the closed beta.",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
    } catch (e) {
      Sentry.captureException(e);
      toast({
        title: "Error",
        description: "There was an error sending your request. Please try again later.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  return (
    <Banner onClose={closeBanner}>
      <Flex gap="1">
        <Text key={notification.notification_id}>{notification.message}</Text>
        <Text onClick={onActionClick} textDecoration="underline" cursor={"pointer"}>
          Request access to the closed beta
        </Text>
      </Flex>
    </Banner>
  );
};
